import Card from "./card";
import styles from "../../styles/_containers/_settings/sections.module.scss";

const SectionThree = ({ data, handleChange }) => {

  return (
    <div className={styles.container}>
      {/* CARD 1 — Communication & client messaging */}
      <Card>
        <div className={styles.cardContainer}>

          {/* BLOCK 1 — WhatsApp / SMS channel */}
          <div className={styles.block}>
            <div className={styles.title}>
              <h4>ערוץ תקשורת עם לקוחות</h4>
              <div className={styles.tag}>
                <p>חשוב</p>
              </div>
            </div>

            <p className={styles.textOne}>
              בחרו האם לשלוח הודעות ללקוחות דרך WhatsApp או SMS
            </p>

            <div className={styles.field}>
              <label>ערוץ שליחה</label>
              <select
                name="communicationChannel"
                value={data.communicationChannel}
                onChange={handleChange}
              >
                <option value="whatsapp">WhatsApp</option>
                <option value="sms">SMS</option>
              </select>
            </div>
          </div>

          {/* BLOCK 2 — Send message on new client */}
          <div className={styles.block}>
            <div className={styles.title}>
              <h4>שליחת הודעה בהוספת לקוח חדש</h4>
            </div>

            <p className={styles.textOne}>
              במידה ופעיל, המערכת תשלח ללקוח הודעת ברוך הבא כאשר נוסף לרשימת הלקוחות
            </p>

            <div className={styles.field}>
              <label>סטטוס</label>
              <select
                name="preventMessageOnClientAdd"
                value={String(data.preventMessageOnClientAdd)}
                onChange={handleChange}
              >
                <option value="false">פעיל — שלח הודעה</option>
                <option value="true">לא פעיל — אל תשלח הודעה</option>
              </select>
            </div>
          </div>

          {/* BLOCK 3 — Manual client registration approval */}
          <div className={`${styles.block} ${styles.lastBlock}`}>
            <div className={styles.title}>
              <h4>אישור לקוחות ידני</h4>
              <div className={styles.tag}>
                <p>חדש</p>
              </div>
            </div>

            <p className={styles.textOne}>
              במידה ופעיל, כל לקוח חדש שנרשם יחייב אישור ידני מצד בעל העסק לפני שיוכל לקבוע תור
            </p>

            <div className={styles.field}>
              <label>סטטוס</label>
              <select
                name="isClientRegistrationConfirmationRequired"
                value={String(data.isClientRegistrationConfirmationRequired)}
                onChange={handleChange}
              >
                <option value="true">פעיל — אישור ידני נדרש</option>
                <option value="false">לא פעיל</option>
              </select>
            </div>
          </div>
        </div>
      </Card>

      {/* CARD 2 — Service selection & booking rules */}
      <Card>
        <div className={styles.cardContainer}>

          {/* BLOCK 1 — Service selection method */}
          <div className={styles.block}>
            <div className={styles.title}>
              <h4>שיטת בחירת שירות</h4>
            </div>

            <p className={styles.textOne}>
              בחרו כיצד הלקוחות יבחרו שירות: בחירת שירות ותאריך ישירות, או קודם בחירת עובד ואז שירות ותאריך
            </p>

            <div className={styles.field}>
              <label>שיטת בחירה</label>
              <select
                name="showCombinedServicesToClients"
                value={String(data.showCombinedServicesToClients)}
                onChange={handleChange}
              >
                <option value="true">שירות, תאריך ושעה (ישיר)</option>
                <option value="false">עובד, שירות, תאריך ושעה</option>
              </select>
            </div>
          </div>

          {/* BLOCK 2 — Double booking */}
          <div className={styles.block}>
            <div className={styles.title}>
              <h4>חסימת "תור כפול"</h4>
            </div>

            <p className={styles.textOne}>
              בחרו האם לאפשר ללקוחות לקבוע יותר מתור אחד. במידה ולא פעיל: לקוח יוכל
              לקבוע תור אחד בלבד עד אשר זמן התור יעבור או שהתור יבוטל
            </p>

            <div className={styles.field}>
              <label>סטטוס</label>
              <select
                name="canBookMoreInServices"
                value={data.canBookMoreInServices}
                onChange={handleChange}
              >
                <option value={true}>לא פעיל — ניתן לקבוע יותר מתור אחד</option>
                <option value={false}>פעיל — מוגבל לתור אחד ללקוח</option>
              </select>
            </div>
          </div>

          {/* BLOCK 3 — Cancellation message */}
          <div className={`${styles.block} ${styles.lastBlock}`}>
            <div className={styles.title}>
              <h4>הודעת ביטול ללקוחות</h4>
            </div>

            <p className={styles.textOne}>
              כאן תוכלו לרשום את מדיניות הביטולים שלכם. הלקוחות יראו את ההודעה
              כאשר זמן הביטול עבר
            </p>

            <div className={styles.field}>
              <textarea
                name="cancellationText"
                value={data.cancellationText}
                onChange={handleChange}
                placeholder="לקוחות יקרים, במידה וברצונכם לבטל את התור אנא בטלו אותו מראש ולא במועד סמוך לתור"
                maxLength={80}
              ></textarea>
              <div className={styles.row}>
                <p>ניתן לרשום עד 80 תווים</p>
                <p>תווים שנותרו: {80 - (data.cancellationText?.length || 0)}</p>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SectionThree;
